import { render, staticRenderFns } from "./createReview.vue?vue&type=template&id=fc2d3bcc&scoped=true&"
import script from "./createReview.vue?vue&type=script&lang=ts&"
export * from "./createReview.vue?vue&type=script&lang=ts&"
import style0 from "./createReview.vue?vue&type=style&index=0&id=fc2d3bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2d3bcc",
  null
  
)

export default component.exports